import * as S from "effect-app/Schema"
import { AiChatInput } from "../AiChat.ts"

export const MAX_AI_ROWS = 800

export class PriceAiRow extends S.Opaque<PriceAiRow, PriceAiRow.Encoded>()(
  S
    .Struct({
      index: S.Int,
      label: S.NonEmptyString2k,
      priceId: S.NullOr(S.NonEmptyString255),
      // the row's current DRAFT values, which is what the model must reason about
      eur: S.NullOr(S.Finite),
      chf: S.NullOr(S.Finite),
      supportsSwissPrice: S.Boolean
    })
    .annotate({ identifier: "PriceAiRow" })
) {}

/*
 * What the model is allowed to say. `rows` carries the semantic selection,
 * `eur`/`chf` carry MathJS expressions evaluated client-side. The model never
 * emits a computed price and never emits a Preis-ID.
 */
export class PricePatch extends S.Opaque<PricePatch, PricePatch.Encoded>()(
  S
    .Struct({
      rows: S.Array(S.Int).pipe(S.check(S.isBetweenLength(0, MAX_AI_ROWS))),
      eur: S.NullOr(S.NonEmptyString),
      chf: S.NullOr(S.NonEmptyString),
      reply: S.NonEmptyString2k
    })
    .annotate({ identifier: "PricePatch" })
) {}

// What one interpretation turn needs, caps included. The single definition of
// the (message, history, rows) shape: the resource spreads these fields into
// its request (plus configuratorId), the service takes exactly this as input.
// A plain Struct on purpose: the type stays structural, so the controller can
// hand the decoded request fields straight through.
export const PriceAiInput = S.Struct({
  ...AiChatInput.fields,
  rows: S.Array(PriceAiRow).pipe(S.check(S.isBetweenLength(1, MAX_AI_ROWS)))
})
export type PriceAiInput = typeof PriceAiInput.Type

// codegen:start {preset: model}
//
export namespace PriceAiRow {
  export interface Encoded extends S.StructNestedEncoded<typeof PriceAiRow> {}
}
export namespace PricePatch {
  export interface Encoded extends S.StructNestedEncoded<typeof PricePatch> {}
}
//
// codegen:end
